module.exports = __webpack_public_path__ + "media/images/product-img-01-8bc0f78831fac54fed73a18912b997b8.png";